import ScrollToTop from "../../components/ScrollToTop.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import WorthToKnowSectionComponent from "../../components/alternative-frontpages/WorthToKnowSectionComponent.tsx";
import WhatYouAreGettingSectionComponent from "../../components/alternative-frontpages/WhatYouAreGettingSectionComponent.tsx";
import WhyChooseHiperSectionComponent from "../../components/alternative-frontpages/WhyChooseHiperSectionComponent.tsx";
import CallMeRTOComponent from "../../components/callMe/CallMeRTOComponent.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import TilbudHeroComponent from "../../components/hero/TilbudHeroComponent.tsx";
import setNoIndexMeta from "../../components/setNoIndexMeta.tsx";
import AlternativeFrontpagesTitleAndMetaDescription from "../../components/alternative-frontpages/AlternativeFrontpagesTitleAndMetaDescription.tsx";

export default function TilbudPage() {
    ScrollToTop()
    useDatalayer()
    setNoIndexMeta()
    AlternativeFrontpagesTitleAndMetaDescription()

    return (
        <div className={"page-campaign-tilbud"}>
            <TilbudHeroComponent/>

            <section className="section-white">
                <div className="content content--medium">
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <div className="content content--slim">
                                <div className="blurb">
                                    <h3 className="heading heading--medium heading--left">Aktivér dit TDC NET fiber nu!</h3>
                                </div>
                                <p>
                                    Har du fået installeret TDC NET fibernet, men endnu ikke fået det aktiveret?
                                </p>
                                <p>
                                    Så kan du nu fremtidssikre din bolig med 1000 Mbit lynhurtigt fibernet fra Hiper – selvfølgelig til en knivskarp pris!
                                </p>
                                <p>
                                    Med fiber fra os får du al den hastighed og stabilitet, du skal bruge til at arbejde, streame og game.
                                    Modsat mobilt bredbånd, som kører på 4G eller 5G netværket, får du med fiber en ultrastabil forbindelse til hjemmet.
                                </p>
                            </div>
                        </li>
                        <li>
                            <div className="content content--slim">
                                <div className="blurb">
                                    <h3 className="heading heading--medium heading--left">
                                        Få 1000 Mbit til kun <strong><span className="hiper-text-stroke">99</span> kr./md.</strong>
                                    </h3>
                                </div>
                                <p>
                                    Lige nu kan du blive koblet på fibernettet helt gratis.
                                    Du får nemlig oprettelse og tilslutning til <strong>0&nbsp;kr.</strong><br/>
                                    <button className={"link"} onClick={() => DispatchHighLightAddressSearchEvent(true)}>
                                        Tjek din adresse her.
                                    </button>
                                </p>
                                <p>
                                    Vi glæder os til at give dit hjem lynhurtigt fiber!
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>

            <CallMeRTOComponent className={"rto--section page-products"}/>
            <WhatYouAreGettingSectionComponent/>
            <WorthToKnowSectionComponent/>
            <WhyChooseHiperSectionComponent/>
        </div>
    )
}
